import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

import ThemeToggle from '../../../components/ui/ThemeToggle';
import { useAuth } from '../../../contexts/AuthContext';


const ThemeCustomizationSection = () => {
  const { user } = useAuth();
  const [hasChanges, setHasChanges] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!user?.id) return;
    try {
      setSaving(true);
      setHasChanges(false);
    } catch (error) {
      console.error('Error saving theme settings:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-card rounded-xl p-6 elevation-2">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-secondary rounded-lg">
            <Icon name="Palette" size={20} color="white" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Personalización de Tema</h2>
            <p className="text-sm text-muted-foreground">Personaliza tu experiencia PrimeOne+</p>
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-medium text-foreground mb-4">Modo y Color Principal</h3>
        <ThemeToggle variant="full" />
      </div>
    </div>
  );
};

export default ThemeCustomizationSection;